import { render, staticRenderFns } from "./EditBorrowOrder.vue?vue&type=template&id=05f5d6da&scoped=true&"
import script from "./EditBorrowOrder.vue?vue&type=script&lang=js&"
export * from "./EditBorrowOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditBorrowOrder.vue?vue&type=style&index=0&id=05f5d6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5d6da",
  null
  
)

export default component.exports